// import React, { useEffect } from 'react';
// import ReactPlayer from 'react-player';
//
// const CustomYoutubePlayer = ({ url }) => {
//     useEffect(() => {
//         // CSS to hide Watch Later and Share buttons inside the YouTube iframe
//         const style = document.createElement('style');
//         style.innerHTML = `
//       iframe {
//         pointer-events: none;  /* Disable interaction to inspect elements */
//       }
//
//       iframe::-webkit-media-controls-enclosure {
//         display: none !important; /* Hide the native YouTube buttons */
//       }
//     `;
//         document.head.appendChild(style);
//
//         // Cleanup on component unmount
//         return () => {
//             document.head.removeChild(style);
//         };
//     }, []);
//
//     return (
//         <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
//             <ReactPlayer
//                 config={{
//                     youtube: {
//                         playerVars: { fs: 0 }  // Disable fullscreen option
//                     }
//                 }}
//                 controls={true}
//                 width="100%"
//                 height="100%"
//                 url={url}
//             />
//         </div>
//     );
// };
//
// export default CustomYoutubePlayer;


import ReactPlayer from "react-player";
import React from "react"

export default function CustomYoutubePlayer({url}) {

    return (
        <div style={{position: 'relative', width: '100%', height: '100vh'}}>
            <ReactPlayer
                config={{
                    youtube: {
                        playerVars: {
                            modestbranding: 1,   // Minimal YouTube branding
                            rel: 0,              // Disable related videos at the end
                            showinfo: 0,         // Deprecated (doesn't fully hide info)
                            fs: 0
                        }
                    }
                }}
                controls={true}
                width="100%"
                height="100%"
                url={url}
            />

            {/* Div to hide the share button (absolute positioned) */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '100%',  // Adjust the size to cover the share button
                    height: '9%',   // Adjust the height to fit
                    backgroundColor: 'transparent',  // You can change the color to match the background
                    zIndex: 1          // Ensure it's on top of the player
                }}
            ></div>
        </div>
    );
}